import { FC, HTMLProps } from 'react';
import { StyledButton, ButtonStyle, ButtonSize } from './Button.styles';

export interface ButtonProps extends HTMLProps<HTMLButtonElement> {
  /** The style of the button */
  $buttonStyle?: ButtonStyle;
  /** The size of the button */
  $buttonSize?: ButtonSize;
  /** Whether the button is loading or not */
  loading?: boolean;
  /** Whether the button is disabled or not */
  disabled?: boolean;
  /** Whether the button fills its container or not */
  $fullWidth?: boolean;
}

export const Button = StyledButton as FC<ButtonProps>;

export default Button;
